import { GET_QUOTE_VALUE } from '../keys'
const initialState = { categorydata: [] }
export default function reducer(state = initialState, action) {
    switch (action.type) {
       
        case GET_QUOTE_VALUE: {
            
            return { ...state, categorydata: action.payload }
        }
        default:
           
            return { ...state }
    }

}